import { createStore as reduxCreateStore } from 'redux';
import * as types from '../constants/ActionTypes';

const reducer = (state, action) => {
    if (action.type === types.SET_HAMBURGER_MENU_STATE) {
        return Object.assign({}, state, { isOpen: action.isOpen });
    }
    if(action.type === types.SET_MAIN_MENU_LIST) {
        return Object.assign ({}, state, { mainMenuList: action.data})
    }
    if (action.type === types.SET_DAR_REPORTS_FILTERS) {
        return {
            ...state,
            DarReportsFilters: {
                ...state.DarReportsFilters, 
                ...action.data              
            }
        };
    }
    if (action.type === types.RESET_DAR_REPORTS_FILTERS) {
        return Object.assign({}, state, {
            DarReportsFilters: {
                visibleCount: 3,
                startDate: null,
                endDate: null,
                checkedItems: {},
                showFiltersMobile: false
            }
        });
    }
    return state;
};

const initialState = {
    isOpen: false,
    mainMenuList: {},
    DarReportsFilters: {
        visibleCount: 3,
        startDate: null,
        endDate: null,
        checkedItems: {}
    }
};

const createStore = () => reduxCreateStore(reducer, initialState)

export default createStore;